// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"aiF3o","splashWrapper":"_3SezQ","base":"_2tv3p","blurred":"_11trS"};